
// ListarAreceber.js

import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
//import Axios from 'axios';
import api from '../config/axiosConfig';


const ListarAreceber = ({ handleSairListarClick, onIdClick }) => {
  const [areceberDaPagina, setAreceberDaPagina] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState('codvenda'); // Estado para armazenar a ordenação selecionada
  const [filtroCodVenda, setFiltroCodVenda] = useState(''); // Estado para o código de venda
  const [isFiltrando, setIsFiltrando] = useState(false); // Controle para o filtro

  useEffect(() => {
    fetchAreceber(currentPage, orderBy);
  }, [currentPage, orderBy]);

  const fetchAreceber = async (page, order = 'codvenda') => {
    try {
      console.log(`Solicitando Areceber da página ${page} ordenados por ${order}...`);
      const response = await api.get(`/areceber/listarareceber/paginados?page=${page - 1}&size=10&sortBy=${order}`);
      
      setAreceberDaPagina(response.data.content);
      setTotalPages(response.data.totalPages);
      console.log(`Areceber da página ${page} ordenados por ${order} carregados com sucesso:`, response.data.content);
    } catch (error) {
      console.error('Erro ao carregar Areceber:', error);
    }
  };

  const buscarPorCodVenda = async () => {
    try {
      if (filtroCodVenda.trim() === '') {
        alert('Por favor, insira um código de venda válido.');
        return;
      }
      console.log(`Buscando parcelas com código de venda: ${filtroCodVenda}`);
      const response = await api.get(`/areceber/${filtroCodVenda}/parcelas`);

      if (response.data && response.data.length > 0) {
        setAreceberDaPagina(response.data);
        setIsFiltrando(true);
        setTotalPages(1); // Ajustar para evitar paginação em busca
      } else {
        alert(`Nenhuma Parcela a Receber para Venda: ${filtroCodVenda}`);
        setAreceberDaPagina([]); // Limpar a tabela
        setIsFiltrando(false); // Desativa o estado de filtragem
      }
    } catch (error) {
      console.error('Erro ao buscar por código de venda:', error);
      setIsFiltrando(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handleOrderByVencimento = () => {
    setOrderBy('dtvencimento');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCodvenda = () => {
    setOrderBy('codvenda');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCliente = () => {
    setOrderBy('nomecli'); // Mudar para ordenar por nome do cliente
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  
  // Função para formatar a data no formato "DD-MM-YYYY"
  const formatarData = (data) => {
  if (!data) return "Data não disponível";
  const partes = data.split('-');
  if (partes.length !== 3) return "Data inválida";
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
  };


  // Função para formatar valores monetários
  const formatarValor = (valor) => {
    return valor ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor) : 'R$ 0,00';
  };


  return (
    <div>
      <Typography variant="h5" gutterBottom>Listagem de Contas a Receber</Typography>


      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <Typography variant="body1" style={{ marginTop: '0px', marginLeft: '20px' }}>
          Página {currentPage} de {totalPages}
        </Typography>

       {/* Botões de Navegação */}
        {!isFiltrando && (
          <Box>
            <ButtonGroup variant="contained" color="primary" style={{ height: '25px', padding: '0px 0px', marginLeft: '20px' }}>
              <Button onClick={handleFirstPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<FirstPageIcon />}></Button>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<NavigateBeforeIcon />}></Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<NavigateNextIcon />}></Button>
              <Button onClick={handleLastPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<LastPageIcon />}></Button>
            </ButtonGroup>
          </Box>
        )}

      </Box>

<Box display="flex" justifyContent="center" alignItems="center" mt={0}>
  {/* Botões de Ordenação e Busca */}
  <Box display="flex" justifyContent="center" alignItems="center" gap={2}>

    {/* Botões de Ordenação */}
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCodvenda}
    >
      Lista Por Venda
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCliente}
    >
      Por Cliente
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByVencimento}
    >
      Por Vencimento
    </Button>
          
    {/* Campo de Busca */}
    <input
      type="text"
      placeholder="Código Venda"
      value={filtroCodVenda}
      onChange={(e) => setFiltroCodVenda(e.target.value)}
      style={{
        padding: '5px',
        width: '100px',
        marginLeft: '30px',
        height: '25px',
        fontSize: '14px'
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={buscarPorCodVenda}
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
    >
      Buscar
    </Button>          
          
    {/* Botão de Fechar à Direita */}
     <button
        type="button"
        className="btn-menu"
        onClick={handleSairListarClick}
        style={{ fontSize: '12px', fontWeight: 'bold', 
          height: '25px', padding: '3px 6px', marginLeft: '30px', width: '80px', color: 'inherit' }}
      >
        Fechar
      </button>
        
        </Box>
      </Box>

    <div style={{ overflowX: 'auto', margin: '20px' }}>
      <table style={{ textAlign: 'left', borderCollapse: 'collapse', width: '100%', minWidth: '800px' }}>
        <thead>
          <tr>
            <th style={{ padding: '10px', width: '80px' }}>Venda</th>
            <th style={{ padding: '10px', width: '150px' }}>Dt Venda</th>
            <th style={{ padding: '10px', width: '250px' }}>Cliente</th>
            <th style={{ padding: '10px', width: '80px' }}>Parcela</th>
            <th style={{ padding: '10px', width: '150px' }}>Val Parcela</th>
            <th style={{ padding: '10px', width: '150px' }}>Vencimento</th>
            <th style={{ padding: '10px', width: '150px' }}>Pagamento</th>
          </tr>
        </thead>
        <tbody>
          {areceberDaPagina.map((areceber) => (
            <tr key={areceber.id}>
              
              <td style={{ padding: '10px', cursor: 'pointer', color: 'blue' }}
                onClick={() => onIdClick(areceber.id)}>{areceber.codvenda}</td>              
              <td style={{ padding: '10px' }}>{formatarData(areceber.dtvenda)}</td>
              <td style={{ padding: '10px' }} className="truncate" title={areceber.nomecli}
               translate="no">{areceber.nomecli}</td>
              <td style={{ padding: '10px' }}>{areceber.parcela}</td>
              <td style={{ padding: '10px' }}>{formatarValor(areceber.valparcela)}</td>
              <td style={{ padding: '10px' }}>{formatarData(areceber.dtvencimento)}</td>
              <td style={{ padding: '10px' }}>{formatarData(areceber.dtpagamento)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      
  </div>
  );
};

export default ListarAreceber;